module.exports = __webpack_public_path__ + "img/address-title-pic.5b11475d.png";